var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppSettings = function SvgAppSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentColor",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.2 7.2c-1.2 0-2.1.9-2.1 2.1s.9 2.1 2.1 2.1 2.1-.9 2.1-2.1-1-2.1-2.1-2.1m6.8 0c-1.2 0-2.1.9-2.1 2.1s.9 2.1 2.1 2.1 2.1-.9 2.1-2.1-1-2.1-2.1-2.1m6.9 4.2c1.2 0 2.1-.9 2.1-2.1s-.9-2.1-2.1-2.1-2.1.9-2.1 2.1.9 2.1 2.1 2.1M9.1 18.1c1.2 0 2.1-.9 2.1-2.1s-.9-2.1-2.1-2.1S7 14.9 7 16s.9 2.1 2.1 2.1m6.8 0c1.2 0 2.1-.9 2.1-2.1s-.9-2.1-2.1-2.1-2.1.9-2.1 2.1 1 2.1 2.1 2.1m6.9 0c1.2 0 2.1-.9 2.1-2.1s-.9-2.1-2.1-2.1-2.1.9-2.1 2.1 1 2.1 2.1 2.1M9.2 20.6c-1.2 0-2.2 1-2.2 2.1 0 1.2.9 2.1 2.1 2.1s2.1-.9 2.1-2.1c.1-1.1-.9-2.1-2-2.1m6.8 0c-1.2 0-2.1.9-2.1 2.1s.9 2.1 2.1 2.1 2.1-.9 2.1-2.1c0-1.1-1-2.1-2.1-2.1m6.9 0c-1.2 0-2.1.9-2.1 2.1s.9 2.1 2.1 2.1 2.1-.9 2.1-2.1c0-1.1-1-2.1-2.1-2.1"
  })));
};
export default SvgAppSettings;